import { ApiResult, CrudService } from 'ui-shared';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { NcmEntity } from "@catalogo/models";
import { CONFIGURACAO_API_URL } from "@catalogo/features/compartilhado/const/constantes";

@Injectable({ providedIn: 'any' })
export class NcmDataService extends CrudService<NcmEntity> {

    protected url: string;

    constructor(
        @Inject(CONFIGURACAO_API_URL) urlBase: string,
        @Inject(HttpClient) protected httpClient: HttpClient
    ) {
        super(urlBase, httpClient);
        this.url = `${urlBase}/v1/ncm`;
    }

    public obterPorCodigo(codigo: string){
        return this.httpClient.get<ApiResult<NcmEntity>>(`${this.url}/codigo/${codigo}`)
    }
}
